import './ContainerizationWhat.css';
import img from "../containassets/whatimage.png";

export default function ContainerizationWhat() {
  return (
    <div id="contain-what" className="outsourcemainclass">
      <div className="left">
        <img src={img} alt="error" />
      </div>
      <div className="right">
        <h2 className="heading">What Is Containerization?</h2>
        <p className="subheading">
          Containerization is a DevOps practice that packages applications,
          dependencies, and configurations into lightweight, standardized
          containers. This ensures applications run consistently across
          development, testing, and production environments, eliminating
          compatibility issues.</p>
          <p className="subheading">
          By isolating applications from underlying infrastructure,
          containerization improves portability, reliability, and scalability.
          It enables faster deployments, efficient resource usage, and seamless
          integration with CI/CD pipelines and cloud platforms.
        </p>
      </div>
    </div>
  );
}
